import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TokenGuard } from './shared/guards/token/token.guard';

const routes: Routes = [
  // {
  //   path: '', pathMatch: 'full', redirectTo: 'home'
  // },
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [TokenGuard]
  },
  {
    path: 'nota-fiscal',
    loadChildren: () => import('./pre-nota/pre-nota.module').then(m => m.PreNotaModule),
    canActivate: [TokenGuard]
  },
  // {
  //   path: 'cotacao',
  //   loadChildren: () => import('./cotacao/cotacao.module').then(m => m.CotacaoModule),
  //   canActivate: [TokenGuard]
  // },
  {
    path: 'reembolsos-despesas',
    loadChildren: () => import('./reembolso-despesas/reembolso-despesas.module').then(m => m.ReembolsoDespesaModule),
    canActivate: [TokenGuard]
  },
  {
    path: 'users/:id/password',
    loadChildren: () => import('./recover-password/recover-password.module').then(m => m.RecoverPasswordModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
